export const safeWindow = typeof window !== "undefined" ? window : undefined;
export const safeSessionStorage =
  typeof sessionStorage !== "undefined" ? sessionStorage : undefined;
export const safeLocalStorage =
  typeof localStorage !== "undefined" ? localStorage : undefined;

export const safeDocument =
  typeof document !== "undefined" ? document : undefined;

export const safeIndexedDB =
  typeof indexedDB !== "undefined" ? indexedDB : undefined;
